import AppWrapper from '@components/AppWrapper';
import LoadingProgress from '@components/LoadingProgress';

const GenericFullLoadingPage = ({
  isAuthorized,
}: {
  isAuthorized: boolean;
}) => {
  return (
    <AppWrapper isAuthorized={isAuthorized}>
      <LoadingProgress height="30vh" />
    </AppWrapper>
  );
};

export default GenericFullLoadingPage;
